// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"48":"8fb1b568","379":"7b9c63df","634":"a9fe65c4"}[chunkId] + ".js";
};